(() => {
  if (customElements.get('tfp-espetit-v3')) return;
  class EspetitPicker extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      const track = this.querySelector('.tfp-catch-track');
      if (track) {
        const controls = this.querySelector('.tfp-catch-controls');
        const prev = this.querySelector('[data-catch-prev]');
        const next = this.querySelector('[data-catch-next]');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max <= 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        };
        const move = direction => {
          const first = track.firstElementChild;
          const amount = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
          track.scrollBy({left: direction * amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        track.addEventListener('scroll', update, {signal, passive:true});
        this._catchResize = new ResizeObserver(update);
        this._catchResize.observe(track);
        update();
      }
      this.radios = Array.from(this.querySelectorAll('input[data-variant]'));
      this.form = this.querySelector('.tfp-v3-form');
      this.variants = new Map(this.radios.map(radio => [radio, JSON.parse(radio.dataset.variant)]));
      this.addEventListener('change', event => {
        if (this.variants.has(event.target)) this.renderSelection(event.target);
      }, { signal });
      const selected = this.radios.find(radio => radio.checked);
      this.renderSelection(selected);
      if (this.form) this.form.addEventListener('submit', event => {
        const current = this.radios.find(radio => radio.checked);
        const variant = this.variants.get(current);
        if (!variant || !variant.id || !variant.available) event.preventDefault();
      }, { signal });
      const bar = this.querySelector('.tfp-live-bar');
      const purchase = this.querySelector('.tfp-purchase');
      if (bar && purchase && window.IntersectionObserver) {
        this._media = window.matchMedia('(max-width: 720px)');
        let passed = false;
        const update = () => { bar.hidden = !this._media.matches || !passed; };
        this._media.addEventListener('change', update, { signal });
        this._observer = new IntersectionObserver(entries => {
          passed = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
          update();
        });
        this._observer.observe(purchase);
      }
    }
    disconnectedCallback() {
      this._catchResize?.disconnect();
      this._controller?.abort();
      this._observer?.disconnect();
      this._controller = null;
    }
    renderSelection(radio) {
      const v = this.variants.get(radio);
      const es = this.lang.toLowerCase().startsWith('es');
      const color = v?.label || (es ? 'Elige tu color' : 'Choose your color');
      this.querySelectorAll('[data-selected-color]').forEach(el => { el.textContent = color; });
      this.querySelectorAll('[data-price]').forEach(el => { el.textContent = v?.price || '—'; });
      const stock = this.querySelector('[data-stock]');
      if (stock) stock.textContent = !v?.id ? (es ? 'No disponible' : 'Unavailable') : v.available ? (es ? 'Disponible' : 'Available') : (es ? 'Agotado · elige otro color' : 'Sold out · choose another color');
      const button = this.querySelector('[data-add]');
      if (button) {
        button.disabled = !v?.id || !v.available;
        button.textContent = v?.id && !v.available ? (es ? 'AGOTADO' : 'SOLD OUT') : (es ? 'AÑADIR AL CARRITO' : 'ADD TO CART');
      }
      const image = this.querySelector('[data-product-image]');
      const empty = this.querySelector('[data-image-empty]');
      if (image) {
        image.hidden = !v?.image;
        image.removeAttribute('srcset');
        if (v?.image) { image.src = v.image; image.alt = `Espetit 95 · ${color}`; }
        else image.removeAttribute('src');
      }
      if (empty) { empty.hidden = Boolean(v?.image); empty.textContent = es ? `Foto pendiente · ${color}` : `Photo pending · ${color}`; }
      const quantity = this.querySelector('input[name="quantity"]');
      if (quantity) {
        const min = v?.min || 1, step = v?.step || 1;
        quantity.min = String(min); quantity.step = String(step);
        if (v?.max != null) quantity.max = String(v.max); else quantity.removeAttribute('max');
        const old = Number(quantity.value);
        if (!Number.isFinite(old) || old < min || (v?.max != null && old > v.max) || (old - min) % step !== 0) quantity.value = String(min);
      }
      const status = this.querySelector('[data-status]');
      if (status) status.textContent = '';
    }
  }
  customElements.define('tfp-espetit-v3', EspetitPicker);
})();
